import { Divider, Typography } from 'antd'
import React from 'react'
import BinInward from '../../../components/Wash/BinInward/BinInward'
import GSMInward from '../../../components/GSuperMarket/GSMInwatd/GSMInward'

const GSMInwardPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Bin Inward
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <GSMInward userData={userData} />
    </>
  )
}

export default GSMInwardPage